import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import '../styles/layout/PageNotFound.css'

const PageNotFound = () => {
  return (
    <div className='pageNotFound'>
      <Container>
        <Row className='justify-content-center'>
          <Col md={8} className='text-center'>
            <h1>404</h1>
            <h4>Page Not Found!</h4>
            <p>Let's go
              <Link to="/"> home </Link> and try from there.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PageNotFound
